import { Row, Steps } from "antd";
import axios from "axios";
import { message } from "components/Messages/Messages";
import TitleUnderlined from "components/TitleUnderlined/TitleUnderlined";
import useViewport from "components/UseViewport/UseViewport";
import { useCallback, useEffect, useState } from "react";
import Booking from "./Booking/Booking";
import Information from "./Information/Information";
import Summary from "./Summary/Summary";
import { BookingSeason, NO_AVAILABLE_SEASON, NoAvailableSeason, UNKNOWN_ERROR, UnknownError } from "./interface";

const EventBooking = () => {
  const [current, setCurrent] = useState(0);
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);
  const [price, setPrice] = useState<string>("");
  const [date, setDate] = useState<Date | undefined>();
  const [description, setDescription] = useState<string | undefined>();
  const [season, setSeason] = useState<BookingSeason | NoAvailableSeason | UnknownError>();

  useEffect(() => {
    axios
      .get<BookingSeason>("/booking-seasons/current/")
      .then(response => {
        setSeason(response.data);
      })
      .catch(response => {
        if (response.status === 404) setSeason(NO_AVAILABLE_SEASON);
        else setSeason(UNKNOWN_ERROR);
      });
  }, []);

  const { width } = useViewport();
  const breakpoint = 850;

  const goToNextStep = useCallback(() => {
    if (!acceptedTerms) return message("error", "Du må godta vilkårene for å gå videre til booking");
    setCurrent(curr => (curr === 3 ? curr : curr + 1));
  }, [acceptedTerms]);

  const goToPreviousStep = useCallback(() => {
    setCurrent(curr => (curr === 0 ? curr : curr - 1));
  }, []);

  return (
    <>
      <Row style={width < breakpoint ? { margin: "3% 2.5%" } : { margin: "3% 10%" }}>
        <TitleUnderlined title="Booking av arrangement" />
        <Steps
          current={current}
          labelPlacement="vertical"
          style={{ padding: "20px 0" }}
          items={[
            {
              title: "Informasjon",
            },
            {
              title: "Booking",
            },
            {
              title: "Oppsummering",
            },
          ]}
        />

        {current === 0 ? (
          <Information
            season={season && season !== NO_AVAILABLE_SEASON && season !== UNKNOWN_ERROR ? season : undefined}
            setAccepted={setAcceptedTerms}
            goToNextStep={goToNextStep}
          />
        ) : current === 1 ? (
          <Booking
            season={season}
            setPrice={setPrice}
            setSelectedDate={setDate}
            setDescription={setDescription}
            goToNextStep={goToNextStep}
            goToPreviousStep={goToPreviousStep}
            selectedDate={date}
            description={description}
          />
        ) : (
          <Summary price={price} bookedDate={date} description={description} />
        )}
      </Row>
    </>
  );
};

export default EventBooking;
